// Soft UI Dashboard PRO React components
import { Grid } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const OnboardingStepContainer = ({ header, subHeader, children }) => {
  return (
    <Box>
      <Box width="100%" textAlign="left" mx="auto" mb={6}>
        <Box mb={1}>
          <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
            {header}
          </Typography>
        </Box>
        <Grid container id="stuffforme">
          <Typography
            variant="body1"
            sx={{ lineHeight: '1.2' }}
            fontSize={{ xs: '16px', sm: '20px' }}
          >
            {subHeader}
          </Typography>
          <Grid item xs={12} mb={2}>
            {children}
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
